import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'

interface Props {
  id: string
  onSuccess?: () => void
  children?: () => ReactElement
}

const DeleteAiEnvironmentRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/agents/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteAiEnvironmentRequest
